import zh from './zh';
import en from './en';

export const i18nMap: any = {
    'zh-CN': zh,
    'en-US': en,
};
